var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.6663C0.5 12.1391 1.69391 13.333 3.16667 13.333H5.83333C7.30609 13.333 8.5 12.1391 8.5 10.6663C8.5 9.19358 7.30609 7.99967 5.83333 7.99967H3.16667C1.69391 7.99967 0.5 6.80577 0.5 5.33301C0.5 3.86025 1.69391 2.66634 3.16667 2.66634H5.83333C7.30609 2.66634 8.5 3.86025 8.5 5.33301M4.5 1.33301V14.6663",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollorIcon);
export default __webpack_public_path__ + "static/media/dollor-icon.a83ce310815ebfc04a02861a9fafc36f.svg";
export { ForwardRef as ReactComponent };